export default "__VITE_ASSET__tbH4jm2Q__"